import moment from "moment";
import { StatusConfigs } from "../configurations";
import { DATE_FORMAT_SL } from "../configurations/status";
import { NotificationEnumns } from "../types/enumerations";
export var formatDataForStatusGraph = function (maintenanceData, incidentsData, maxFutureDateCount) {
    var prodMaintenances = {}, prodIncidents = {};
    var stageMaintenences = {}, stageIncidents = {};
    var ongoingProdMaintenances = {}, ongoingProdIncidents = {};
    var ongoingStageMaintenances = {}, ongoingStageIncidents = {};
    var today = moment();
    var todayString = today.format(DATE_FORMAT_SL);
    var maxFutureDateString = today.add(maxFutureDateCount, 'day').format(DATE_FORMAT_SL);
    maintenanceData.forEach(function (notification) {
        var _a, _b;
        var isProd = ((_a = notification === null || notification === void 0 ? void 0 : notification.environment) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "production";
        var startDate = notification === null || notification === void 0 ? void 0 : notification.startTime;
        var dateString = moment(startDate).format(DATE_FORMAT_SL);
        if (moment(dateString, DATE_FORMAT_SL).isAfter(moment(maxFutureDateString, DATE_FORMAT_SL))) {
            dateString = maxFutureDateString;
        }
        var existingNotfOnThisDate = isProd ? (prodMaintenances === null || prodMaintenances === void 0 ? void 0 : prodMaintenances[dateString]) || [] : (stageMaintenences === null || stageMaintenences === void 0 ? void 0 : stageMaintenences[dateString]) || [];
        var existingOngoingNotfThisDate = isProd ? (ongoingProdMaintenances === null || ongoingProdMaintenances === void 0 ? void 0 : ongoingProdMaintenances[todayString]) || [] : (ongoingStageMaintenances === null || ongoingStageMaintenances === void 0 ? void 0 : ongoingStageMaintenances[todayString]) || [];
        var ongoingStatusList = StatusConfigs.ongoingNotificationMap[NotificationEnumns.NOTIFICATION_TYPE.MAINTENANCE];
        var briefNotf = {
            id: notification === null || notification === void 0 ? void 0 : notification.id,
            created: notification === null || notification === void 0 ? void 0 : notification.created,
            startTime: notification === null || notification === void 0 ? void 0 : notification.startTime,
            endTime: notification === null || notification === void 0 ? void 0 : notification.endTime,
            status: notification === null || notification === void 0 ? void 0 : notification.status,
            type: NotificationEnumns.NOTIFICATION_TYPE.MAINTENANCE
        };
        existingNotfOnThisDate.push(briefNotf);
        if (ongoingStatusList.includes((_b = notification.status) === null || _b === void 0 ? void 0 : _b.id))
            existingOngoingNotfThisDate.push(briefNotf);
        if (isProd) {
            prodMaintenances[dateString] = existingNotfOnThisDate;
            ongoingProdMaintenances[todayString] = existingOngoingNotfThisDate;
        }
        else {
            stageMaintenences[dateString] = existingNotfOnThisDate;
            ongoingStageMaintenances[todayString] = existingOngoingNotfThisDate;
        }
    });
    incidentsData.forEach(function (notification) {
        var _a, _b;
        var isProd = ((_a = notification === null || notification === void 0 ? void 0 : notification.environment) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "production";
        var startDate = notification === null || notification === void 0 ? void 0 : notification.startTime;
        var dateString = moment(startDate).format(DATE_FORMAT_SL);
        if (moment(dateString, DATE_FORMAT_SL).isAfter(moment(maxFutureDateString, DATE_FORMAT_SL))) {
            dateString = maxFutureDateString;
        }
        var existingNotfOnThisDate = isProd ? (prodIncidents === null || prodIncidents === void 0 ? void 0 : prodIncidents[dateString]) || [] : (stageIncidents === null || stageIncidents === void 0 ? void 0 : stageIncidents[dateString]) || [];
        var existingOngoingNotfThisDate = isProd ? (ongoingProdIncidents === null || ongoingProdIncidents === void 0 ? void 0 : ongoingProdIncidents[todayString]) || [] : (ongoingStageIncidents === null || ongoingStageIncidents === void 0 ? void 0 : ongoingStageIncidents[todayString]) || [];
        var ongoingStatusList = StatusConfigs.ongoingNotificationMap[NotificationEnumns.NOTIFICATION_TYPE.INCIDENTS];
        var briefNotf = {
            id: notification === null || notification === void 0 ? void 0 : notification.id,
            created: notification === null || notification === void 0 ? void 0 : notification.created,
            startTime: notification === null || notification === void 0 ? void 0 : notification.startTime,
            endTime: notification === null || notification === void 0 ? void 0 : notification.endTime,
            status: notification === null || notification === void 0 ? void 0 : notification.status,
            type: NotificationEnumns.NOTIFICATION_TYPE.INCIDENTS
        };
        existingNotfOnThisDate.push(briefNotf);
        if (ongoingStatusList.includes((_b = notification.status) === null || _b === void 0 ? void 0 : _b.id))
            existingOngoingNotfThisDate.push(briefNotf);
        if (isProd) {
            prodIncidents[dateString] = existingNotfOnThisDate;
            ongoingProdIncidents[todayString] = existingOngoingNotfThisDate;
        }
        else {
            stageIncidents[dateString] = existingNotfOnThisDate;
            ongoingStageIncidents[todayString] = existingOngoingNotfThisDate;
        }
    });
    return {
        production: {
            incidents: prodIncidents,
            maintenances: prodMaintenances
        },
        stage: {
            incidents: stageIncidents,
            maintenances: stageMaintenences
        },
        ongoingProduction: {
            incidents: ongoingProdIncidents,
            maintenances: ongoingProdMaintenances
        },
        ongoingStage: {
            incidents: ongoingStageIncidents,
            maintenances: ongoingStageMaintenances
        }
    };
};
//# sourceMappingURL=status.js.map